import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as ArrowUpRight } from '../../../assets/icons/ArrowUpRight.svg';
import Context from '../../../store/context';
import useGet from '../../../services/hooks/http/useGet';
import apiMethods from '../../../apis';
import utils from '../../../services/utils';
import { paths } from '../../../routes';
import HeadPay from '../../ResultPay/HeadPay/HeadPay';
import AgreementResult from '../../ResultPay/AgreementResult/AgreementResult';
import NoticeCard from '../../NoticeCard/NoticeCard';
import Button from '../../Buttons/Button/Button';
import DetailOneInvoice from './DetailsAgreements/DetailOneInvoice/DetailOneInvoice';

import classes from './ResultAgreementPay.module.scss';

const ResultAgreementPay = ({ dataPayAgreement, methodForPay, costTransaction }) => {
  
  const [fetchGetState, setFetchGetState] = useState(false);
  const [agroupAgreementsState, setAgroupAgreementsState] = useState([]);

  const {
    modal: { showModal, showError, hideModal }
  } = useContext(Context);

  useEffect(() => {
    
    if (!dataPayAgreement || !dataPayAgreement.agreementsPayouts || dataPayAgreement.agreementsPayouts.length === 0) {
      setAgroupAgreementsState([]);
      return;
    }
    
    let agroupAgreements = [];
    for (const agreement of dataPayAgreement.agreementsPayouts) {
      const positionAgreementExits = agroupAgreements.findIndex((agreementAgroup, idx) => {
        return agreementAgroup.agreementId === agreement.agreementId;
      });

      if (positionAgreementExits === -1) {
        agroupAgreements.push({
          agreementId: agreement.agreementId,
          agreementName: agreement.agreementName,
          totalToPay: agreement.payedValue,
          isShowInvoices: false,
          invoices: [
            {
              meloStatus: agreement.meloStatus,
              meloStatusDescription: agreement.meloStatusDescription,
              valueToPay: agreement.payedValue,
              number: agreement.referenceId,
              issueDate: agreement.issueDate,
              description: agreement.description
            }
          ]
        });
      } else {
        agroupAgreements[positionAgreementExits] = {
          ...agroupAgreements[positionAgreementExits],
          totalToPay: agroupAgreements[positionAgreementExits].totalToPay + agreement.payedValue,
          invoices: [
            ...agroupAgreements[positionAgreementExits].invoices,
            ...[
              {
                meloStatus: agreement.meloStatus,
                meloStatusDescription: agreement.meloStatusDescription,
                valueToPay: agreement.payedValue,
                number: agreement.referenceId,
                issueDate: agreement.issueDate,
                description: agreement.description
              }
            ]
          ]
        };
      }
    }
    setAgroupAgreementsState(agroupAgreements);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { businessId } = useSelector(state => state.userData);
  const navigate = useNavigate();

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getAgreementsPayoutVoucher, [businessId, dataPayAgreement.payoutId], fetchGetState);

  const downloadVoucher = () => {
    // No descargar comprobante para pagos de Cybersource
    if (methodForPay === 'cybersource' || dataPayAgreement.payoutId?.includes('mock_')) {
      showError({ title: 'Comprobante no disponible', description: 'Los comprobantes para pagos con tarjeta de crédito no están disponibles en este momento.' });
      return;
    }
    setFetchGetState(true);
  };
  useEffect(() => {
    if (getPayedVoucherSuccess) {
      utils.downloadFileByUrl(getPayedVoucher);
      setFetchGetState(false);
    } else if (getPayedVoucherError) {
      showError({ title: 'Descargar comprobante', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  const goInvoicesView = () => {
    navigate(`${paths.agreements}#historyPay`);
  };

  const showDetailsAgreements = (invoice, agreementName) => {
    //showModal(<DetailsAgreements agreement={agreement} />);
    showModal(<DetailOneInvoice invoiceSelected={{ ...invoice, agreementName }} setInvoiceSelected={hideModal} />);
  };

  return (
    <div className={classes.content}>
      <HeadPay
        text={`${dataPayAgreement.totalAgreements} cuenta de cobro de ${agroupAgreementsState.length} empresa o servicio`}
        totalToPay={dataPayAgreement.totalValue}
      />
      <div className={`${classes.card} card-formGrid`}>
        <AgreementResult
          methodForPay={methodForPay}
          agroupAgreementsState={agroupAgreementsState}
          setAgroupAgreementsState={setAgroupAgreementsState}
          dataPayAgreement={dataPayAgreement}
          showDetailsAgreements={showDetailsAgreements}
          costTransaction={costTransaction}
        />

        <NoticeCard
          className={classes.notice}
          text='Una vez el pago sea aprobado (máx. 1 día hábil), automáticamente se te enviará un correo de confirmación del pago con los detalles.'
        />
      </div>
      <div className={classes.buttons}>
        <Button onClick={downloadVoucher} Icon={ArrowDownLine}>
          Descargar comprobante
        </Button>
        <Button className={classes.button} Icon={ArrowUpRight} custom='secondary' onClick={goInvoicesView}>
          Ir a Pagos en proceso
        </Button>
      </div>
    </div>
  );
};

export default ResultAgreementPay;
